import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Checkbox } from 'ui-cubic'

const StyledCheckbox = styled(Checkbox)`
  padding-left: 26px !important;

`

const CheckboxBordered = props => {
  const { input, label, ...rest } = props

  return (

    <StyledCheckbox
      label={label}
      {...input}
      {...rest}
    />
  )
}

CheckboxBordered.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired
}

export default CheckboxBordered
